import React from 'react'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useIntl } from 'react-intl'
import messages from './messages'
import BulkAddTasksModal from './components/BulkAddTasksModal'
import NiceModal from '@ebay/nice-modal-react'

const BulkAddTasks = ({ order, refetch, readOnly = false }) => {
  const { formatMessage } = useIntl()

  return (
    <Menu.Item key='bulkAddTasks' disabled={readOnly}>
      {(props) => (
        <MenuButton
          disabled={readOnly}
          {...props}
          onClick={() => NiceModal.show(BulkAddTasksModal, { order, refetch })}
        >
          { formatMessage(messages.title) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default BulkAddTasks
